<template>
  <div class="header">
    <div class="header-return" v-if="showReturn">
      <van-icon name="arrow-left" size="1.25rem" color="white" @click="retFunt" />
    </div>
    <div class="header-title">{{ title }}</div>
    <div class="header-home" v-if="showHome">
      <van-icon name="wap-home-o" size="1.25rem" color="white" @click="$utils.routerPush('/mobile')" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '机上销售',
    },
    pageName: {
      type: String,
      default: 'Home',
    },
  },
  data() {
    return {
      isReturn: true,
      showHome: true
    }
  },
  computed: {
    showReturn() {
      return !['Content', 'OvernightBag'].includes(this.pageName)
    }
  },
  created() {
    this.$EventBus.$on('setIsReturn', (value) => {
      this.isReturn = value
    })
    this.$EventBus.$on('setShowHome', (value) => {
      this.showHome = value
    })
  },
  methods: {
    retFunt() {
      window.history.back()
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  position: relative;
  text-align: center;
  .header-title {
    width: 100%;
    height: 3.125rem;
    background: #e1514c;
    line-height: 3.125rem;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
  .header-return {
    height: 50px;
    position: absolute;
    left: 0.5rem;
    display: flex;
    align-items: center;
  }
  .header-home {
    height: 50px;
    position: absolute;
    top: 0;
    right: 0.5rem;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Header.vue